import * as React from 'react';
import { ToastContainer, toast } from 'react-toastify';

import Message from '../Message'

const toastOptions : any  = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  customId:  "custom-id-yes"
  }

import './styles.scss'

class Notification extends React.PureComponent { 
  render(){
    return (
      <div>      
        <ToastContainer/>
      </div>
    );
  }  
}

export function Toast(type: string, message: string , title? : string): any{
  switch(type){
    case 'info':
      return toast.info(message,toastOptions)
    case 'success':
      return toast.success(<Message title={title} message={message}/> ,toastOptions)
    case 'error':
      return toast.error(message,toastOptions)    
  }
}

export default Notification;